import React, { useEffect } from "react";
import Image from "next/image";
import {
  Box,
  Menu,
  Typography,
  Link,
  ListItemButton,
  List,
  ListItemText,
  Button,
  Avatar,
  Divider,
  Chip,
} from "@mui/material";

import { onSignOut } from "../../../src/utils/queries";
import { useRouter } from "next/router";
import { useAuthProvider } from "../../../context/AuthProvider";
const ProfileDD = () => {
  const [anchorEl4, setAnchorEl4] = React.useState(null);
  const { user, email, first_name, last_name, clearState } = useAuthProvider();
  const { mutate, data, isSuccess } = onSignOut();

  const router = useRouter();
  useEffect(() => {
    if (isSuccess) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("isSubsidiary");
      router.replace("/login");
      clearState()
    }
  }, [isSuccess]);

  const handleClick4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };

  const handleClose4 = () => {
    setAnchorEl4(null);
  };

  const reroute = () => {
    router.push("/settings");
  };
  return (
    <>
      <Chip
        label={user?.role?.name ? user.role.name : null}
        size="small"
        sx={{
          bgcolor: "success.light",
          color: "success.dark",
          fontWeight: "600",
          borderRadius: "4px",
          fontSize: "10px",
          height: "16px",
        }}
      />
      <Button
        aria-label="menu"
        color="inherit"
        aria-controls="profile-menu"
        aria-haspopup="true"
        onClick={handleClick4}
      >
        <Avatar
          sx={{
            width: 50,
            height: 50,
            fontSize: "10px",
            fontWeight: 600,
            border: "2px solid white",
            background: "s",
          }}
          src={user?.profile_image}
          alt={user?.first_name}
        >
          {!user?.profile_image &&
            `${first_name?.charAt(0)} ${last_name?.charAt(0)}`}
        </Avatar>
      </Button>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl4}
        keepMounted
        open={Boolean(anchorEl4)}
        onClose={handleClose4}
        sx={{
          "& .MuiMenu-paper": {
            width: "385px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar
            sx={{
              width: 50,
              height: 50,
              fontSize: "10px",
              fontWeight: 600,
              border: "2px solid white",
              background: "s",
            }}
            src={user?.profile_image}
            alt={user?.first_name}
          >
            {!user?.profile_image &&
              `${first_name?.charAt(0)} ${last_name?.charAt(0)}`}
          </Avatar>
          <Typography
            variant="big"
            sx={{ fontWeight: 700, textAlign: "center", marginTop: "10px" }}
          >
            {first_name + " " + last_name}
            <Typography
              variant="small"
              component={"p"}
              sx={{ fontWeight: 400 }}
            >
              {email}
            </Typography>
          </Typography>
        </Box>
        <Box>
          <Box p={2} pt={0}>
            <List
              component="nav"
              aria-label="secondary mailbox folder"
              onClick={handleClose4}
            >
              <ListItemButton onClick={reroute}>
                <ListItemText
                  sx={{
                    color: "#425A70",
                    fontSize: "14px",
                    lineHeight: "20px",
                    marginTop: "10px",
                  }}
                  primary="Edit Profile"
                />
              </ListItemButton>
              <ListItemButton onClick={reroute}>
                <ListItemText   sx={{
                    color: "#425A70",
                    fontSize: "14px",
                    lineHeight: "20px",
                    marginTop: "10px",
                  }} primary="Change Password" />
              </ListItemButton>
              <ListItemButton onClick={reroute}>
                <ListItemText   sx={{
                    color: "#425A70",
                    fontSize: "14px",
                    lineHeight: "20px",
                    marginTop: "10px",
                  }} primary="My Settings" />
              </ListItemButton>
            </List>
          </Box>
          <Divider />
          <Box p={2}>
            <Link to="/">
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                  mutate();
                }}
              >
                Logout
              </Button>
            </Link>
          </Box>
        </Box>
      </Menu>
    </>
  );
};

export default ProfileDD;
